module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_left_Light Blue_disabled.9f2c86c2.svg";